import styled, { css } from "styled-components";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Image from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { AvailabilityBadges } from "../../../../../../../common-deprecated/components/aem/toyota/availability-badges/styles/AvailabilityBadgesStyles";

export const Wrapper = styled.div<{ hasBgImage: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;

    @media ${getBreakpoint("down", "md")} {
        flex-wrap: wrap;
    }

    @media ${getBreakpoint("up", "xl")} {
        position: relative;
        flex-direction: row;
    }

    ${({ hasBgImage }) =>
        hasBgImage &&
        css`
            margin-left: -2rem;
            margin-right: -2rem;
        `};
`;

export const Title = styled(Type.H1)`
    padding-bottom: 0;
    font-family: ${theme.fonts.semiBold};
    line-height: 1.2;
`;

export const HeroImageWrapper = styled(Flex.Col)`
    display: flex;
    flex-grow: 1;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    z-index: -1;

    @media ${getBreakpoint("up", "xl")} {
        width: 75%;
        max-width: 100%;
    }
`;

export const Heading = styled(Flex.Col)<{ hasBgImage: boolean }>`
    width: 100%;
    margin: 0;
    padding: 0 0 0 ${theme.space[3]}px;
    text-align: start;

    @media ${getBreakpoint("up", "md")} {
        padding: 0 ${theme.space[3]}px 0 0;
    }

    @media ${getBreakpoint("up", "xl")} {
        width: 25%;
    }

    ${({ hasBgImage }) =>
        hasBgImage &&
        css`
            + ${HeroImageWrapper} {
                margin-top: 4rem;
                padding: 0;
            }

            @media ${getBreakpoint("up", "xl")} {
                position: absolute;
                top: 1rem;
                left: 2.4rem;
                z-index: 1;

                + ${HeroImageWrapper} {
                    margin-top: 0px;
                }
            }
        `};

    ${AvailabilityBadges} {
        margin-top: ${theme.space[2]}px;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const HeroImage = styled(Image.ImageFluid)`
    @media ${getBreakpoint("down", "sm")} {
        margin-left: auto;
        margin-right: auto;
    }

    /* Fix to align the image with the top. All images has some white-space at the top */
    @media ${getBreakpoint("up", "md")} {
        margin-top: -25px;
    }
`;
export const GRLogo = styled.div`
    position: absolute;
    top: 0;
    right: 0;

    html[dir="rtl"] & {
        left: 0;
        right: auto;
    }
`;

export const HeroBg = styled(Image.ImageFluid)``;
